import { Text, Flex, Link } from "@chakra-ui/react"

const Footer = () => {
  return (
    <Flex
      width="100%"
      backgroundColor="brand.500"
      flexDirection={["column", "column", "row", "row"]}
      paddingLeft="10vw"
      paddingRight="10vw"
      paddingTop="16px"
      paddingBottom="16px"
    >
      <Flex
        justifyContent={["center", "center", "flex-start", "flex-start"]}
        alignItems="center"
        width={["100%", "100%", "30%", "30%"]}
      >
        <Text
          color="white"
          marginTop="8px"
          marginLeft="8px"
          marginRight="8px"
          marginBottom={["16px", "16px", "8px", "8px"]}
        >
          © CEZ Vanzare 2021
        </Text>
      </Flex>
      <Flex
        flexDirection={["column", "column", "row", "row"]}
        alignItems="center"
        justifyContent={["center", "center", "flex-end", "flex-end"]}
        flexGrow="1"
      >
        <Link
          color="white"
          margin="8px"
          href="https://mycez.cezinfo.ro/web/guest/formulare-utile"
        >
          Utile
        </Link>
        <Link
          color="white"
          margin="8px"
          href="https://www.cez.ro/ro/contactati-ne.html"
        >
          Contact
        </Link>
        <Link
          color="white"
          margin="8px"
          href="https://mycez.cezinfo.ro/web/guest/politica-de-confidentialitate"
        >
          Politica confidentialitate
        </Link>
        <Link color="white" margin="8px" href="https://www.cezinfo.ro/cookies/">
          Politica Cookie
        </Link>
        <Link
          color="white"
          margin="8px"
          href="https://mycez.cezinfo.ro/web/guest/termeni-si-conditii"
        >
          Termeni si conditii
        </Link>
        <Link color="white" margin="8px" href="https://www.cez.ro/ro">
          www.cez.ro
        </Link>
        <Link color="white" margin="8px" href="https://www.cezinfo.ro/">
          www.cezinfo.ro
        </Link>
      </Flex>
    </Flex>
  )
}

export default Footer
